/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxItemChannel } from './MailboxItemChannel';
import {
    MailboxItemChannelFromJSON,
    MailboxItemChannelFromJSONTyped,
    MailboxItemChannelToJSON,
    MailboxItemChannelToJSONTyped,
} from './MailboxItemChannel';

/**
 * 
 * @export
 * @interface MailboxRenderResultDTO
 */
export interface MailboxRenderResultDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxRenderResultDTO
     */
    Subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxRenderResultDTO
     */
    Body?: string | null;
    /**
     * 
     * @type {MailboxItemChannel}
     * @memberof MailboxRenderResultDTO
     */
    Channel?: MailboxItemChannel;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailboxRenderResultDTO
     */
    UnresolvedPlaceholders?: Array<string> | null;
}



/**
 * Check if a given object implements the MailboxRenderResultDTO interface.
 */
export function instanceOfMailboxRenderResultDTO(value: object): value is MailboxRenderResultDTO {
    return true;
}

export function MailboxRenderResultDTOFromJSON(json: any): MailboxRenderResultDTO {
    return MailboxRenderResultDTOFromJSONTyped(json, false);
}

export function MailboxRenderResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxRenderResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Subject': json['Subject'] == null ? undefined : json['Subject'],
        'Body': json['Body'] == null ? undefined : json['Body'],
        'Channel': json['Channel'] == null ? undefined : MailboxItemChannelFromJSON(json['Channel']),
        'UnresolvedPlaceholders': json['UnresolvedPlaceholders'] == null ? undefined : json['UnresolvedPlaceholders'],
    };
}

export function MailboxRenderResultDTOToJSON(json: any): MailboxRenderResultDTO {
    return MailboxRenderResultDTOToJSONTyped(json, false);
}

export function MailboxRenderResultDTOToJSONTyped(value?: MailboxRenderResultDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Subject': value['Subject'],
        'Body': value['Body'],
        'Channel': MailboxItemChannelToJSON(value['Channel']),
        'UnresolvedPlaceholders': value['UnresolvedPlaceholders'],
    };
}

